module.exports = __webpack_public_path__ + "static/media/logo-novo-nordisk-fonden.6d83acdb.svg";